module.exports = __webpack_public_path__ + "static/media/grsnylon.e83a390f.png";